import React, { FC } from 'react';
import styles from './Container.module.css';

interface ContainerProps {
    classes?: string;
    type?: 'default' | 'fluid';
    customSize?: 'custom-small' | 'custom-medium' | 'custom-large';
    children?: JSX.Element | JSX.Element[];
}

export const Container: FC<ContainerProps> = ({ classes, type, customSize, children }) => {
    return (
        <div
            className={`${type === 'fluid' ? 'container-fluid' : `container ${styles.container}`} ${classes || ''}`}
            data-testid="container">
            {customSize ? (
                <div
                    className={
                        (customSize === 'custom-small' ? styles['custom-container-size-1'] : '') +
                        (customSize === 'custom-medium' ? styles['custom-container-size-2'] : '') +
                        (customSize === 'custom-large' ? styles['custom-container-size-3'] : '')
                    }>
                    {children}
                </div>
            ) : (
                children
            )}
        </div>
    );
};
